import {
  useHomeAdaptiveSubjectsQuery,
  useHomeAllAdaptiveSubjectsQuery
} from '../HomeAdaptiveSubjects.queries.generated';

export interface HomeAdaptiveSubject {
  id: string;
  name: string;
  urlSlug: string;
}

interface HomeAdaptiveSubjectsResult {
  subjects: HomeAdaptiveSubject[];
  loading: boolean;
}

/**
 * Adaptive subjects to suggest on Home, personalized by the teacher's curriculum area(s). Falls back to
 * the full adaptive catalog when the teacher's areas map to none OR the personalized query fails
 */
export const useHomeAdaptiveSubjects = (): HomeAdaptiveSubjectsResult => {
  const {data, loading, error} = useHomeAdaptiveSubjectsQuery({
    fetchPolicy: 'cache-and-network'
  });
  const personalized = data?.subjects?.results ?? [];
  const needsFallback = personalized.length === 0 && (data !== undefined || Boolean(error));

  const {data: fallbackData, loading: fallbackLoading} = useHomeAllAdaptiveSubjectsQuery({
    skip: !needsFallback
  });

  if (needsFallback) {
    return {
      subjects: fallbackData?.subjects?.results ?? [],
      loading: fallbackLoading
    };
  }

  return {subjects: personalized, loading};
};
